<template>
  <div>
    <GlobalAlert ref="globalAlert" />
    <router-view />
  </div>
</template>

<script>
import GlobalAlert from './components/alert.vue';

export default {
  name: 'App',
  components: { GlobalAlert },
  setup() {
    
    return{
      
    }
  },
};
</script>
